import { Controller, FieldErrors, useFormContext } from 'react-hook-form';
import { TextInput } from '@/components/form/TextInput.tsx';
import TemplateRichTextEditor from '@/features/dashboard/templateImages/components/TemplateRichTextEditor.tsx';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import SingleFileInput from '@/components/form/SingleFileInput.tsx';
import { ConsentTemplateInputData } from '@/features/dashboard/consentTemplates/schemas/consentTemplateSchema.ts';
import useGetConsentTemplateVariables from '@/features/dashboard/consentTemplates/hooks/useGetConsentTemplateVariables.ts';
import { ConsentType } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.ts';

function getFieldError(errors: FieldErrors, field: string): string | undefined {
  return (errors[field] as { message?: string } | undefined)?.message;
}

const FILE_ACCEPT = { 'application/pdf': ['.pdf'] };

const ConsentTemplateForm = () => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext<ConsentTemplateInputData>();

  const { data: variables } = useGetConsentTemplateVariables();

  const type = watch('type');

  return (
    <>
      <TextInput
        label="Nazwa"
        required
        placeholder="Nazwa szablonu zgody"
        register={register('name')}
        error={errors.name?.message}
      />

      {type === ConsentType.TEMPLATE && (
        <div>
          <InputLabel label="Treść szablonu" required />
          <Controller
            control={control}
            name="documentTemplate"
            render={({ field }) => (
              <TemplateRichTextEditor
                content={field.value ?? ''}
                onChange={field.onChange}
                variables={variables}
                error={getFieldError(errors, 'documentTemplate')}
              />
            )}
          />
          <InputError error={getFieldError(errors, 'documentTemplate')} />
        </div>
      )}

      {type === ConsentType.LINK && (
        <TextInput
          label="Adres URL"
          required
          placeholder="https://example.com/regulamin"
          register={register('linkUrl' as 'name')}
          error={getFieldError(errors, 'linkUrl')}
        />
      )}

      {type === ConsentType.FILE && (
        <SingleFileInput
          fieldName="consentFile"
          accept={FILE_ACCEPT}
          label="Plik"
          required
          removable={false}
          hint="PDF"
          error={getFieldError(errors, 'consentFile')}
        />
      )}
    </>
  );
};

export default ConsentTemplateForm;
